import React from "react";
import './Secthree.css';

export default function () {
    return (

        <section className="Sec-3 pt-5">   {/* section three strat with content */}

            <h1 className=" text-center fw-bold"><span className="sec-3-main-heading">How It works ? </span></h1>

            <div className="container">
                <div className="row  pt-5">
                    <div className="bg-color-icons border col-12 col-md-3  text-center p-5">
                        <i class="bi bi-globe fs-1 "></i>
                        <h2 className="pt-2">Traders and investors </h2>

                    </div>
                    <div className="bg-color-icons border col-12 col-md-3  text-center p-5">
                        <i class="bi bi-pc-display-horizontal fs-1"></i>
                        <h2 className="pt-2 text-center">Exchanges</h2>
                    </div>
                    <div className="bg-color-icons border col-12 col-md-3  text-center p-5">
                        <i class="bi bi-currency-exchange fs-1"></i>
                        <h2 className="pt-2">Miners</h2>
                    </div>
                    <div className="bg-color-icons border col-12 col-md-3  text-center p-5">
                        <i class="bi bi-wallet2 fs-1"></i>
                        <h2 className="pt-2">Payments</h2>
                    </div>

                </div>

                <div className="text-center pt-5">
                    <button type="button" className="sec-3-btn-2 rounded p-3">
                        Read More
                    </button>
                </div>

                <div className="pt-5">
                    <h1 className="text-center"><span className="sec-3-main-heading fw-bold">About Cryptop</span></h1>

                    <div className="text-center">
                        <img src="images/about-img.png" alt="" className="img-fluid " />
                    </div>

                    <p className="text-center text-dark ">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniamLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                    </p>

                    <div className="text-center pt-5">
                        <button type="button" className="sec-3-btn-2 rounded p-3">
                            Read More
                        </button>
                    </div>

                </div>

            </div>

        </section>

    )
}
